export default [
    'PartNumber',
    'Desc',
    'stock_wichita',
    'stock_other',
    'stock',
    'stock_service',
    'list_price',
    'your_price',
    'discount',
    'isProprietary',
    'Locations',
    'ServiceCenters',
    'SubstituteParts',
    'Notes',
    'MinOrder',
    'UnitOfMeasure',
    'CoreDeposit',
    'HazardousMat',
    'ShelfLife',
    'ShelfLifeTerm',
    'ShelfLifeDays',
    'HasMandatorySub',
    'IsReturnable',
    'errors'
]